var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73854 18.2307L11.4527 12.5236L12.4646 13.5336L6.75049 19.2407L5.73854 18.2307Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.418 23L12.4167 22L14.2762 20.1429H8.41184L8.41184 18.7143L14.2762 18.7143L12.4167 16.8571L13.418 15.8571L16.9938 19.4286L13.418 23Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9939 17.2857H15.5635V13.7143C15.5635 13.5 15.6351 13.3571 15.7781 13.2143L18.7103 10.2857C19.926 9.07143 20.5697 7.42857 20.5697 5.71429V4.42857H19.2109C17.4945 4.42857 15.8496 5.07143 14.6338 6.28571L11.7017 9.21429C11.6301 9.35714 11.4871 9.42857 11.2726 9.42857H5.90885L4.04943 11.7857L7.83979 12.3571L7.62524 13.7857L2.61911 13.0714C2.33304 13 2.11849 12.8571 2.04698 12.6429C1.97546 12.4286 1.97546 12.1429 2.11849 11.9286L4.97914 8.35714C5.12217 8.07143 5.33672 8 5.55127 8H10.9865L13.7041 5.28571C15.1344 3.78571 17.1369 3 19.2109 3H20.5697C21.3564 3 22 3.64286 22 4.42857V5.78571C22 7.85714 21.2133 9.85714 19.7115 11.3571L16.9939 14V17.2857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.4d0d0cbf51af61b75596e41b8971b921.svg";
export { ForwardRef as ReactComponent };